export default "__VITE_ASSET__Woshk$XF__"